import React from 'react';
import { Rotations } from './components/Rotations';

const RotationsApp = props => <Rotations {...props} />;

export default RotationsApp;
